import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { CommonService } from 'src/app/services/common.service';
import { SsoService } from 'src/app/services/sso.service';
@Component({
  selector: 'app-sso-landing',
  templateUrl: './sso-landing.page.html',
  styleUrls: ['./sso-landing.page.scss'],
})
export class SsoLandingPage implements OnInit {
  user: string = '';
  partner: string = '';
  mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  constructor(private route: ActivatedRoute, private router: Router, public _commonService: CommonService, private ssoService:SsoService) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this._commonService.redirectURL = null;
    this._commonService.showDashboardTiles = true;
    this._commonService.isAdmin = false;
    this._commonService.isCustomerAdmin = false;
    this._commonService.isCustomerUser = false;
    this._commonService.isJuristUser = false;
    this._commonService.isSupportUser = false;
    this._commonService.isLoggedIn = false;
    this._commonService.clearData();
    this.route.queryParams
      .subscribe(params => {
        console.log(params); 
        this.user = params.user ? params.user : ''; 
        this.partner = params.partner ? params.partner : '';
        if(this.user.match(this.mailformat)) {
          this.checkUser();
        } else {
          this.ssoService.presentAlertConfirm(this._commonService.getLocalTranslation('label-invalidEmail'));
        }
      }
    );
  }

  async checkUser() {
    try {
      this._commonService.presentLoading();
      let response  = await this.ssoService.checkUser(this.user, this.partner);
      if(response.body){
        let user = response.body.UserExists ? response.body.UserExists : false;
        if(user) {
          this.getSSOURL();
        } 
      }
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
      if('UserExists' in error) {
        this.router.navigate(['/registration'], { queryParams: { user: this.user, ssoId: this.partner }});
      } else {
        this.ssoService.presentAlertConfirm(error.message)
      }
    }
  }

  async getSSOURL() {
    try {
      let response  = await this.ssoService.getSSOURL(this.partner);
      this._commonService.dismiss();
      if(response.body){
        let SSOURL = response.body.Url;
        window.open(SSOURL,"_self");
      }
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
      this.router.navigate(['/login']);
    }
  }  

}
